<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OGHjMR/tc-custom/9781631952258.jpg?1726519033401" alt="This image is the cover for the book All We Need Is a Pair of Pliers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All We Need Is a Pair of Pliers
      </h1>
      <p class="bookDescription body article font2">
        <b>The inspiring story of how God saved a rebellious young man and inspired him to help countless others through his international wheelchair organization.</b><br/><br/>Mark Richard was in his early teens when his parents divorced. From then on, he and his brothers grew up with minimal parental supervision. He also struggled with undiagnosed learning disabilities which led to failures in school. These circumstances led Mark to a rime of rebellion during the days of the hippy culture and drugs. Yet, throughout it all, Mark always sought something “more” in his life. <br/><br/>Miraculously, God caught Mark’s attention and he was saved. Though he was totally unqualified for the ministry that God planned for him, he followed the path with faith and courage. If Mark had taken others’ advice, he would never have driven a trailer full of wheelchairs to Guatemala in 1988. But over time, that act of obedience grew into a ministry that has impacted hundreds of thousands. <br/><br/><i>All We Need is a Pair of Pliers</i> shows how Mark developed The Beeline, an organization that offers appropriate wheelchair to the millions across the globe who need them. Throughout its pages, readers learn that all they need to say is, “You know what, I think God can use me!”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Richard, June Gaston
      </h2>
      
      <p class="authorDescription body article"><B>Mark Richard</B> currently resides in Guatemala with his wife Esther, splitting his time between the wheelchair factory and the coffee farm. God uniquely prepared him in many different ways throughout his life for his calling– no school could have taught what Mark learned as he journeyed through life, paying attention to God’s hand on him.<br/><br/><B>June Gaston</B> resides in South Dakota with her husband, Kent. She is an educator who met Mark doing mission work and realized that his story needed to be told.<br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74660a4c